/* Tildas category page: filters apply as soon as a box is ticked or the sort changes (a plain GET
   form, so without JavaScript the "Använd" button does the same), and only one filter dropdown is
   open at a time. Escape or a click outside closes it. */
(function () {
  function init(root) {
    var form = root.querySelector('[data-tb-filters]');
    if (!form || form.dataset.tbBooted) return;
    form.dataset.tbBooted = '1';
    var dropdowns = form.querySelectorAll('[data-tb-filter]');

    form.addEventListener('change', function (e) {
      var t = e.target;
      if (t.type === 'checkbox' || t.hasAttribute('data-tb-autosubmit')) form.submit();
    });
    form.addEventListener('submit', function () {
      // drop empty fields so the URL stays clean (price range left blank)
      form.querySelectorAll('input[type="number"]').forEach(function (i) { if (i.value === '') i.disabled = true; });
    });
    dropdowns.forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (!d.open) return;
        dropdowns.forEach(function (o) { if (o !== d) o.open = false; });
      });
    });
    document.addEventListener('click', function (e) {
      dropdowns.forEach(function (d) { if (d.open && !d.contains(e.target)) d.open = false; });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      dropdowns.forEach(function (d) { if (d.open) { d.open = false; d.querySelector('summary').focus(); } });
    });
  }
  function boot() { document.querySelectorAll('[data-tb-collection]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
